module.exports = {"name":"Test","icon":"<i class='material-icons'>bug_report</i>","widget":{"type":"test","initData":{}}}


//////////////////
// WEBPACK FOOTER
// ./src/blocks/test/test.json
// module id = 396
// module chunks = 0